import React from "react";
import { LightBoxCartFilled } from "../vectors/AddToCartIcon";
import ContrastForegroundUtility from "../../../../utils/ContrastForegroundUtility";

interface RemoveFromCartButtonProps {
  primaryColor: string;
  handleClick: Function;
}

const RemoveFromCartButton: React.FC<RemoveFromCartButtonProps> = ({
  primaryColor,
  handleClick
}) => (
  <div
    className="geo-lt__cart-icon geo-btn--caps"
    onClick={e => {
      e.preventDefault();
      handleClick();
    }}
    style={{
      border: `1px solid ${ContrastForegroundUtility.lbFgColor(primaryColor)}`,
      color: ContrastForegroundUtility.lbFgColor(primaryColor)
    }}
  >
    <LightBoxCartFilled
      color={ContrastForegroundUtility.lbFgColor(primaryColor)}
    />
    <span>&nbsp; Remove</span>
  </div>
);

export default RemoveFromCartButton;
